module.exports = __webpack_public_path__ + "static/img/1844_phase_function_Paper_PointsHejduk_Prediction.9c0cba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1844_phase_function_Paper_PointsHejduk_Prediction.png
// module id = F5Zg
// module chunks = 0